// LocalDB.js — storage backend router
//
// Every other file in the app imports THIS module (as it always imported
// the old indexDB.js) and never talks to a backend directly. Adding a new
// backend later means: write the file, add one branch below, done — no
// call-site changes anywhere in the app.
//
// Current backends:
//   web / PWA (browser)         -> IndexDB.js        (IndexedDB, unchanged from before)
//   native Android               -> AndroidSqliteDB.js (SQLite via @capacitor-community/sqlite)
//
// Planned, not yet implemented — add each as its own file with the same
// 5-function API (addItems, updateItems, getItems, getUserDetails,
// deleteItems) and wire it into resolveBackend() below:
//   native iOS                   -> IOSSqliteDB.js     (same @capacitor-community/sqlite plugin,
//                                                        iOS just needs its own file if the
//                                                        storage location/config ends up differing)
//   Windows (Electron/desktop)   -> WindowsMongoDB.js   (MongoDB driver instead of SQLite)
//   Connected-to-server mode     -> LanDB.js            (talks to a DB server over the LAN instead
//                                                        of writing locally at all — this is a
//                                                        *mode* more than a platform, so
//                                                        resolveBackend() will need a runtime check,
//                                                        e.g. a Vuex flag or saved connection config,
//                                                        not just Capacitor.getPlatform())

import { Capacitor } from '@capacitor/core'
import IndexDB from './IndexDB'
import AndroidSqliteDB from './AndroidSqliteDB' 

const resolveBackend = () => {
  const platform = Capacitor.getPlatform() // 'web' | 'android' | 'ios'

  console.log(platform,"platform.............");
  

  switch (platform) {
    case 'android':
      return AndroidSqliteDB
    // case 'ios':
    //   return IOSSqliteDB
    case 'web':
    default:
      return IndexDB
  }

  // TODO when LanDB.js exists: check a runtime "connected to server" flag
  // (e.g. store.state.items.COMPANY_SETTINGS or similar) BEFORE the switch
  // above and return LanDB in that case, regardless of platform.
}

const backend = resolveBackend()

export default {
  addItems: backend.addItems,
  updateItems: backend.updateItems,
  getItems: backend.getItems,
  getUserDetails: backend.getUserDetails,
  deleteItems: backend.deleteItems
}